<app-portal-collapsible
    [title]="title()"
    subtitle="Versichertes Fahrrad"
    icon="bike-1"
    [alert]="!isComplete() ? 'Rahmennummer fehlt' : undefined"
>
    @if (!isComplete()) {
        <i
            collapsibleHeading
            class="c:red"
            ctrlIcon="warning"
            aria-label="Nicht vollständing"
        ></i>
    }
    @if (isComplete()) {
        <dl class="grid-container vertical-gutter-lg">
            <app-portal-widget-details
                class="g-12 sm:g-6"
                heading="Kaufpreis"
                detail="{{ price() }} Euros"
            ></app-portal-widget-details>
            <app-portal-widget-details
                class="g-12 sm:g-6"
                heading="Rahmennummer"
                [detail]="frameNumber()"
            >
            </app-portal-widget-details>
        </dl>
    } @else {
        <form
            [formGroup]="formGroup"
            (ngSubmit)="onSubmit()"
        >
            <div class="grid-container vertical-gutter-lg">
                <dl class="g-12 sm:g-6">
                    <app-portal-widget-details
                        heading="Kaufpreis"
                        detail="{{ price() }} Euros"
                    ></app-portal-widget-details>
                </dl>
                <div class="g-12 sm:g-6 form-control">
                    <label
                        >Rahmennummer:
                        <input
                            formControlName="frameNumber"
                            placeholder="Rahmennummer"
                            autofocus
                            [attr.aria-errormessage]="errorId"
                            [attr.aria-invalid]="showError()"
                            required
                            minlength="3"
                        />
                    </label>

                    @if (showError('required')) {
                        <span
                            [id]="errorId"
                            class="form-error-note"
                            aria-live="polite"
                            >Bitte gib die Rahmennummer des Fahrrads an.</span
                        >
                    } @else if (showError('minlength')) {
                        <span
                            [id]="errorId"
                            class="form-error-note"
                            aria-live="polite"
                        >
                            Die Rahmennummer sollte mindestens drei Zeichen lang sein.
                        </span>
                    }
                </div>
                <button
                    class="g-12 sm:g-6 sm:g-offset-6 -blue"
                    type="submit"
                    [disabled]="formGroup.invalid"
                >
                    <i ctrlIcon="save"></i>Speichern
                </button>
            </div>
        </form>
    }
</app-portal-collapsible>
